export const ipvServiceImplFactory = ({
  ipvRepository,
}: {
  ipvRepository: IIPVRepository;
}) => {
  const getIPVNotesListService: IGetIPVNotesListService = async ({
    clinicId,
    startDate,
    endDate,
  }) => {
    try {
      const response = await ipvRepository.getIPVNotesList({
        clinic_id: clinicId,
        status: 1,
        start_date: startDate,
        end_date: endDate,
      });

      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  const addIPVNotesAckService: IAddIPVNotesAckService = async (payload) => {
    try {
      const response = await ipvRepository.addIPVNotesAck(payload);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      return {
        success: false,
        error: { message: (error as unknown as Error).message },
      };
    }
  };

  return {
    getIPVNotesListService,
    addIPVNotesAckService,
  };
};
